(function(){"use strict";try{if(typeof document<"u"){var e=document.createElement("style");e.appendChild(document.createTextNode("input[data-v-e04a3c23]{min-width:0;background:none;outline:none}input[type=search][data-v-e04a3c23]::-webkit-search-cancel-button{display:none}")),document.head.appendChild(e)}}catch(n){console.error("vite-plugin-css-injected-by-js",n)}})();
import { defineComponent as H, reactive as P, ref as S, computed as y, toRef as T, resolveComponent as a, openBlock as n, createElementBlock as c, normalizeClass as F, createBlock as s, withCtx as t, renderSlot as i, createTextVNode as p, toDisplayString as d, createCommentVNode as v, createElementVNode as L, createVNode as C, createSlots as w, withDirectives as B, mergeProps as K, vModelDynamic as R, Fragment as z, withModifiers as q, vShow as E } from "vue";
import { useIdAttribute as U, useControlAttributes as j, useValidationAttributes as G, useProxyModelValue as J, useResponsive as Q } from "@onereach/ui-components-common/hooks";
import { O as W } from "./OrError-B5ihH6-3.mjs";
import { O as X } from "./OrHint-NvbZyURY.mjs";
import { O as Y } from "./OrIconButton-BlHCLpeW.mjs";
import { O as Z } from "./OrIcon-k8cyvh-D.mjs";
import { O as M } from "./OrInputBox-6ciokFdU.mjs";
import { a as x } from "./OrInputBox.vue_vue_type_script_lang-q2L7rmth.mjs";
import { O as _ } from "./OrLabel-K7_HgvcK.mjs";
import { O as ee } from "./OrLoader-2SaTMxmZ.mjs";
import { _ as oe } from "./_plugin-vue_export-helper-CHgC5LLL.mjs";
const re = [
  // Layout
  "layout-column",
  // Spacing
  "gap-xs"
], ne = [
  // Box
  "flex-auto",
  // Typography
  "typography-inherit",
  // Theme (placeholder)
  "placeholder:theme-foreground-outline",
  "dark:placeholder:theme-foreground-outline-dark",
  // Autofill hack,
  // disable (delay color change)
  "autofill:transition-colors autofill:duration-[5000s]",
  // override background color using box-shadow
  "autofill:shadow-[10px_0_1000px_theme(backgroundColor.primary-opacity-0-08)_inset]",
  "dark:autofill:shadow-[0_0_0px_1000px_theme(backgroundColor.primary-opacity-0-08-dark)_inset]"
];
var N = /* @__PURE__ */ ((e) => (e.Text = "text", e.Number = "number", e.Password = "password", e.Search = "search", e))(N || {}), D = /* @__PURE__ */ ((e) => (e.None = "none", e.Text = "text", e.Tel = "tel", e.Url = "url", e.Email = "email", e.Numeric = "numeric", e.Decimal = "decimal", e.Search = "search", e))(D || {});
const te = H({
  name: "OrInput",
  components: {
    OrError: W,
    OrHint: X,
    OrIcon: Z,
    OrIconButton: Y,
    OrInputBox: M,
    OrLabel: _,
    OrLoader: ee
  },
  model: {
    prop: "modelValue",
    event: "update:modelValue"
  },
  props: {
    modelValue: {
      type: void 0,
      default: void 0
    },
    name: {
      type: String,
      default: void 0
    },
    type: {
      type: String,
      default: () => N.Text
    },
    autocomplete: {
      type: String,
      default: "off"
    },
    inputmode: {
      type: String,
      default: D.Text
    },
    variant: {
      type: String,
      default: void 0
    },
    size: {
      type: String,
      default: void 0
    },
    label: {
      type: String,
      default: void 0
    },
    placeholder: {
      type: String,
      default: void 0
    },
    hint: {
      type: String,
      default: void 0
    },
    error: {
      type: [String, Boolean],
      default: void 0
    },
    loading: {
      type: Boolean,
      default: !1
    },
    required: {
      type: Boolean,
      default: !1
    },
    readonly: {
      type: Boolean,
      default: !1
    },
    disabled: {
      type: Boolean,
      default: !1
    }
  },
  emits: [
    "update:modelValue",
    "input",
    "keydown",
    "keyup",
    "focus",
    "blur"
  ],
  expose: [
    "root",
    "clear",
    "focus",
    "blur"
  ],
  setup(e, o) {
    const b = P({
      id: U(),
      ...j(),
      ...G()
    }), V = S(), I = y(() => [
      "or-input-v3",
      ...re,
      ...e.variant === x.Embedded ? ["grow"] : []
    ]), m = S(), g = y(() => [
      ...ne
    ]), u = J(T(e, "modelValue"), o.emit), f = S(!1), h = y(() => {
      var l;
      return ((l = u.value) == null ? void 0 : l.toString().length) ?? 0;
    }), O = y(() => b.maxlength);
    function k() {
      u.value = void 0;
    }
    function $() {
      var l;
      (l = m.value) == null || l.focus();
    }
    function r() {
      var l;
      (l = m.value) == null || l.blur();
    }
    const { isMobile: A } = Q();
    return {
      attributes: b,
      root: V,
      rootStyles: I,
      control: m,
      controlStyles: g,
      model: u,
      disclosed: f,
      length: h,
      maxLength: O,
      clear: k,
      focus: $,
      blur: r,
      isMobile: A
    };
  }
}), le = { class: "layout-row gap-md md:gap-md" }, ae = ["name", "type", "inputmode", "autocomplete", "placeholder", "required", "readonly", "disabled"];
function ie(e, o, b, V, I, m) {
  const g = a("OrLabel"), u = a("OrLoader"), f = a("OrIconButton"), h = a("OrIcon"), O = a("OrInputBox"), k = a("OrHint"), $ = a("OrError");
  return n(), c("div", {
    ref: "root",
    class: F(e.rootStyles)
  }, [
    e.$slots.label || e.$slots.addon || e.label ? (n(), s(g, {
      key: 0,
      "control-id": e.attributes.id,
      variant: "input",
      required: e.required,
      disabled: e.disabled
    }, {
      addon: t(() => [
        i(e.$slots, "addon", {}, void 0, !0)
      ]),
      default: t(() => [
        i(e.$slots, "label", {}, () => [
          p(d(e.label), 1)
        ], !0)
      ]),
      _: 3
    }, 8, ["control-id", "required", "disabled"])) : v("", !0),
    L("div", le, [
      i(e.$slots, "prepend", {}, void 0, !0),
      C(O, {
        variant: e.variant,
        size: e.size,
        invalid: !!e.error,
        readonly: e.readonly || e.loading,
        disabled: e.disabled
      }, w({
        default: t(() => [
          B(L("input", K({ ref: "control" }, e.attributes, {
            "onUpdate:modelValue": o[0] || (o[0] = (r) => e.model = r),
            class: e.controlStyles,
            name: e.name,
            type: e.type === "password" && e.disclosed ? "text" : e.type,
            inputmode: e.inputmode,
            autocomplete: e.autocomplete,
            placeholder: e.placeholder,
            required: e.required,
            readonly: e.readonly || e.loading,
            disabled: e.disabled,
            onInput: o[1] || (o[1] = (r) => e.$emit("input", r)),
            onKeydown: o[2] || (o[2] = (r) => e.$emit("keydown", r)),
            onKeyup: o[3] || (o[3] = (r) => e.$emit("keyup", r)),
            onFocus: o[4] || (o[4] = (r) => e.$emit("focus", r)),
            onBlur: o[5] || (o[5] = (r) => e.$emit("blur", r))
          }), null, 16, ae), [
            [
              R,
              e.model,
              void 0,
              { trim: !0 }
            ]
          ])
        ]),
        _: 2
      }, [
        e.$slots.prependInner ? {
          name: "prepend",
          fn: t(() => [
            i(e.$slots, "prependInner", {}, void 0, !0)
          ]),
          key: "0"
        } : void 0,
        e.loading || e.type === "password" || e.type === "search" || e.$slots.appendInner ? {
          name: "addon",
          fn: t(() => [
            i(e.$slots, "appendInner", {}, () => [
              e.loading ? (n(), s(u, {
                key: 0,
                variant: "circular",
                color: e.error ? "danger" : "primary",
                size: e.isMobile ? "m" : "s"
              }, null, 8, ["color", "size"])) : (n(), c(z, { key: 1 }, [
                e.type === "password" ? (n(), s(f, {
                  key: 0,
                  icon: { icon: e.disclosed ? "visibility" : "visibility_off", variant: "filled" },
                  size: "l",
                  color: "inherit",
                  disabled: e.disabled,
                  onClick: o[6] || (o[6] = q((r) => e.disclosed = !e.disclosed, ["stop"]))
                }, null, 8, ["icon", "disabled"])) : v("", !0),
                e.type === "search" ? (n(), c(z, { key: 1 }, [
                  e.modelValue && !e.readonly ? (n(), s(f, {
                    key: 0,
                    icon: "close",
                    color: "inherit",
                    size: "l",
                    disabled: e.disabled,
                    onClick: o[7] || (o[7] = q((r) => e.clear(), ["stop"]))
                  }, null, 8, ["disabled"])) : (n(), s(h, {
                    key: 1,
                    icon: "search",
                    size: "l",
                    variant: "outlined"
                  }))
                ], 64)) : v("", !0)
              ], 64))
            ], !0)
          ]),
          key: "1"
        } : void 0
      ]), 1032, ["variant", "size", "invalid", "readonly", "disabled"]),
      i(e.$slots, "append", {}, void 0, !0)
    ]),
    e.$slots.hint || e.hint || e.maxLength ? B((n(), s(k, {
      key: 1,
      disabled: e.disabled
    }, w({
      default: t(() => [
        i(e.$slots, "hint", {}, () => [
          p(d(e.hint), 1)
        ], !0)
      ]),
      _: 2
    }, [
      e.maxLength ? {
        name: "addon",
        fn: t(() => [
          p(d(e.length) + " / " + d(e.maxLength), 1)
        ]),
        key: "0"
      } : void 0
    ]), 1032, ["disabled"])), [
      [E, !e.error]
    ]) : v("", !0),
    B(C($, { disabled: e.disabled }, w({
      default: t(() => [
        p(d(e.error) + " ", 1)
      ]),
      _: 2
    }, [
      e.maxLength ? {
        name: "addon",
        fn: t(() => [
          p(d(e.length) + " / " + d(e.maxLength), 1)
        ]),
        key: "0"
      } : void 0
    ]), 1032, ["disabled"]), [
      [E, typeof e.error == "string" && e.error.length > 0]
    ])
  ], 2);
}
const Oe = /* @__PURE__ */ oe(te, [["render", ie], ["__scopeId", "data-v-e04a3c23"]]);
export {
  N as I,
  Oe as O,
  D as a
};
//# sourceMappingURL=OrInput-BqDsy3wR.mjs.map
